import { render, staticRenderFns } from "./change-subsys.vue?vue&type=template&id=d19c2b46&scoped=true&"
import script from "./change-subsys.vue?vue&type=script&lang=ts&"
export * from "./change-subsys.vue?vue&type=script&lang=ts&"
import style0 from "./change-subsys.vue?vue&type=style&index=0&id=d19c2b46&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d19c2b46",
  null
  
)

export default component.exports